import { Injectable } from '@angular/core';
import { StorageService } from 'ngx-lib';
import { IUser } from '../interfaces/user.interface';

@Injectable({
    providedIn: 'root'
})
export class UserStorageService {
    private readonly _userKey = 'user';

    constructor(private readonly storageService: StorageService) {}

    getUser(): IUser | undefined {
        return this.storageService.getItem(this._userKey);
    }

    setUser(user: IUser) {
        this.storageService.setItem(this._userKey, user);
    }

    removeUser() {
        this.storageService.removeItem(this._userKey);
    }
}
